export default function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex items-start sm:items-end justify-between gap-4 flex-wrap" data-testid="page-header">
      <div className="min-w-0">
        {eyebrow && <div className="text-overline text-primary mb-2 sm:mb-3">{eyebrow}</div>}
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">{title}</h1>
        {subtitle && <p className="mt-2 sm:mt-3 text-sm sm:text-base text-muted-foreground max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
